import { MChatPerguntaEnum, MChatRfPerguntaRespostaInput } from 'graphql/types.generated'
import { isUndefinedOrNull } from 'util/checks'

import { convertSimNaoEnumToBoolean } from '../../converter-consultaSeguimento'
import { ConsultaSeguimentoPergunta09Model } from './model-consultaSeguimentoPergunta09'

export const convertConsultaSeguimentoPergunta09ToInput = (
  value: ConsultaSeguimentoPergunta09Model
): Array<MChatRfPerguntaRespostaInput> => {
  const caminho: MChatRfPerguntaRespostaInput[] = [
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_09_01,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_09_HEADER),
    },
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_09_02,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_09_TRAZ_PRA_VOCE?.FIGURA_OU_BRINQUEDO),
    },
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_09_03,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_09_TRAZ_PRA_VOCE?.DESENHO_QUE_ELE_FEZ),
    },
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_09_04,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_09_TRAZ_PRA_VOCE?.FLOR_QUE_ELE_PEGOU),
    },
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_09_05,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_09_TRAZ_PRA_VOCE?.BICHINHO_QUE_ELE_ENCONTROU),
    },
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_09_06,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_09_TRAZ_PRA_VOCE?.PECAS_QUE_ELE_JUNTOU),
    },
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_09_08,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_09_SO_PARA_MOSTRAR),
    },
  ]

  return caminho.filter((item) => !isUndefinedOrNull(item.stResposta))
}
